module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path != '/agentservices') ? _c('div', [_c('router-view')], 1) : _c('div', {
    staticClass: "main-wrap"
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "6em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Welcome, "), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.user.user_name))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#242323",
      "font-size": "18px"
    }
  }, [_vm._v("Manage your Agent Services")]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "1em 0.2em",
      "padding": "1em",
      "background-color": "#297af5",
      "border-radius": "5px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "margin-top": "-0.5em"
    }
  }, [(_vm.service_charge_balance < 10000) ? _c('span', {
    staticStyle: {
      "float": "left",
      "width": "85%",
      "color": "#ffffff"
    }
  }, [_vm._v("\r\n            Your Service Charge is low, it may not cover your Agent Service payments\r\n            ")]) : _vm._e(), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "col-xs-12 mp0"
  }, [_c('div', {
    staticClass: "col-xs-6 mp0"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "-0.2em",
      "color": "#ffffff",
      "padding": "1em",
      "background-color": "#5703a5",
      "border-radius": "12px",
      "margin-right": "0.5em"
    }
  }, [_vm._m(2), _vm._v(" "), _c('h3', [_c('span', {
    staticClass: "nra-fmt"
  }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(_vm.service_charge_balance)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 mp0"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "color": "#000000",
      "padding": "1em",
      "background-color": "#F8B940",
      "border-radius": "12px",
      "margin-left": "0.5em",
      "margin-right": "0.5em"
    }
  }, [_vm._m(3), _vm._v(" "), _c('h3', [_c('span', {
    staticClass: "nra-fmt"
  }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(_vm.earnings_balance)))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "color": "#000000",
      "padding": "1em",
      "background-color": "#F8B940",
      "border-radius": "12px",
      "margin-left": "0.5em",
      "margin-right": "0.1em"
    }
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "0.4em",
      "padding": "0 0em",
      "font-size": "18px"
    }
  }, [_c('h5', {
    staticStyle: {
      "float": "left",
      "font-size": "16px"
    }
  }, [_vm._v("Total amount earned today:")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right",
      "padding-top": "0.41em"
    }
  }, [_c('span', {
    staticClass: "nra-fmt"
  }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(_vm.earnings_balance)))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "display": "none",
      "background-color": "rgb(41, 122, 245)",
      "width": "100%",
      "border-radius": "8px",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.prepSetCustomAgentBusiness()
      }
    }
  }, [_c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Service Charge Balance:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.sellpoint.business_processing_fee_balance && (_vm.sellpoint.business_processing_fee_balance > 0)) ? _c('span', [_c('span', {
    staticClass: "nra-fmt"
  }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(_vm.sellpoint.business_processing_fee_balance)))]) : _c('span', [_c('span', {
    staticClass: "nra-fmt"
  }, [_vm._v("₦‎")]), _vm._v(_vm._s(_vm.formatCurrency_2(_vm.service_charge_balance)))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [(_vm.site_user_type == 3) ? _c('div', {
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('h4', {
    staticStyle: {
      "color": "#5703a5"
    }
  }, [_vm._v("Agent services you can do")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10)]) : _c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('div', [_c('div', {
    staticClass: "card",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', {
    staticStyle: {
      "color": "#242323"
    }
  }, [_vm._v("Turn on Agent Services")]), _vm._v(" "), _c('p', [_vm._v("An Agent business account would be created for you. You will get to earn from\r\n                    service charges paid when creating shop accounts, managing shops, making orders and more")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "background-color": "rgb(41, 122, 245)",
      "border-radius": "18px",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.prepSetCustomAgentBusiness()
      }
    }
  }, [_vm._v("\r\n                   "), (_vm.action_loading) ? _c('i', {
    staticClass: "fas fa-circle-o-notch fa-spin",
    staticStyle: {
      "color": "#ffffff"
    }
  }) : _vm._e(), _vm._v(" Yes, Turn on my Agent Services")]), _vm._v(" "), _c('br'), _c('br')])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15)])])])])]), _vm._v(" "), _c('component-footer')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin-top": "-1em",
      "color": "#ffffff"
    }
  }, [_c('a', {
    staticClass: "card-link"
  }, [_vm._v("x")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "right",
      "width": "15%",
      "text-align": "right"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "background-color": "#eee",
      "color": "#5703a5",
      "text-decoration": "none"
    },
    attrs: {
      "href": "/agentservices/servicecharges"
    }
  }, [_vm._v("Add")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_vm._v("Service Charge"), _c('br'), _vm._v("Balance")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {}, [_vm._v("Earnings"), _c('br'), _vm._v("Available")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 mp0",
    staticStyle: {
      "background-color": "#ffffff",
      "border-radius": "12px"
    }
  }, [_c('div', {
    staticClass: "col-xs-6 w-any",
    staticStyle: {
      "border-right": "solid 3px #eee"
    }
  }, [_c('h5', [_vm._v("Shop Accounts")]), _vm._v(" "), _c('p', [_vm._v("0")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 w-any"
  }, [_c('h5', [_vm._v("Successful Orders")]), _vm._v(" "), _c('p', [_vm._v("0")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "right",
      "color": "#5703a5"
    }
  }, [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "/agentservices/addedservices"
    }
  }, [_vm._v("\r\n                View all added services  \r\n                "), _c('i', {
    staticClass: "fas fa-angle-right",
    staticStyle: {
      "color": "#5703a5",
      "font-size": "16px"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq card-active"
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/agentservices/setupshop"
    }
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Create a Shop Account")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Upload Product")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Make Orders")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Service Charges ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq card-na"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Manage your Account ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq card-na"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Create a Shop Account")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq card-na"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Upload Product")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq card-na"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Make Orders")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq card-na"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Service Charges ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq card-na"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Manage your Account ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77ba6769"}!./src/pages/AgentServices/Template/template.html
// module id = 604
// module chunks = 0